<template>
  <div class="ts-app-shell_fh">
    <div class="ts-app-landing-dashboard">
      <br />
      <div class="padd-main">
        <el-row :gutter="20">
          <el-col :span="5" style="text-align: center">
            <el-card :body-style="{ padding: '0px' }" shadow="hover">
              <div class="card-body" @click="goToWioaDashboard">
                <h6 class="card-font">WIOA <br />Eligibility</h6>
                <div class="dash-card">
                  <i class="fa fa-list"></i>
                </div>
                <div class="bottom clearfix">
                  <span slot="footer" class="ts-modal--footer">
                    <el-button class="ts-btn-small card-button">View</el-button>
                  </span>
                </div>
              </div>
            </el-card>
          </el-col>

          <el-col :span="15" :offset="1">
            <br />
            <br />
            <br />
            <h6 class="card-font">Complete WIOA Checklist</h6>
            <br />
            <p>Complete your WIOA Checklist.</p>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goToWioaDashboard() {
      this.$router.push({ name: "WioaDashboard" });
    }
  }
};
</script>
